import { render, staticRenderFns } from "./product-recomendation.vue?vue&type=template&id=1c1a9714&"
import script from "./product-recomendation.vue?vue&type=script&lang=js&"
export * from "./product-recomendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports